import BaseAction from "./BaseAction";
import AuthorisationModalReducer from "../reducers/AuthorisationModalReducer";

class AuthorisationModalAction extends BaseAction {
  toggle = (open) => this.dispatch({ open });
}

const action = new AuthorisationModalAction(AuthorisationModalReducer);

export default action;
